//Components
import NavbarItem from "./NavbarItem";
import HeaderMenuDropdown from "./HeaderMenuDropdown";
import { AnimatedDropdownMenu } from "./AnimatedDropdownMenu";
//MUI
import { Stack } from "@mui/material";
//Hooks
import useNavbarConfig from "../hooks/useNavbarConfig";
import { useMemo } from "react";

export default function AnimatedNavbar() {
	const { navbarConfig } = useNavbarConfig();

	const slotProps = useMemo(
		() => navbarConfig.map((config, index) => ({ id: config.title, title: config.title, actions: config.actions, index })),
		[navbarConfig]
	);
	const dropdowns = useMemo(
		() => navbarConfig.map(({ menuConfiguration }) => <HeaderMenuDropdown {...menuConfiguration} />),
		[navbarConfig]
	);

	return (
		<Stack direction="row" className="w-full h-full justify-around">
			<AnimatedDropdownMenu ButtonSlot={NavbarItem} slotProps={slotProps} menuDropdowns={dropdowns} />
		</Stack>
	);
}
